import "./App.css";
import NavigationBar from "./pages/NavigationBar";

function App() {
  return (
    <div>
      <NavigationBar />
    </div>
  );
}

export default App;
